module.exports = __webpack_public_path__ + "school/img/chujiKc.57a4afd9.jpg";